import { createContext } from 'react'

interface IProps {
	resource: string
	onDelete: (entity: any) => void
}

const ResourceContext = createContext<IProps | null>(null)
export default ResourceContext
